import React, { useEffect, useState, useCallback } from 'react'
import { CSVLink } from 'react-csv'
import Pagination from '../Paginations'
import * as echarts from 'echarts'
import ReactEcharts from "echarts-for-react"
import { snakeToCamel } from './AdminEditRelease'
import { getUserAnalytics } from '../../api/user'
import { useQuery } from '@tanstack/react-query'
import {Shimmer} from 'react-shimmer'
import useAnalyticsStore from '../../store/analyticsStore'
import ReleaseStatsTable from '../Dashboard/release_table'
import TopList from '../Dashboard/TopList'
import TopPlatformList from '../Dashboard/TopPlatformList'

export const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

const AdminAnalytics = () => {

  const [searchQuery, setSearchQuery] = useState('');

  // Use analytics store instead of local state
  const { 
    filteredValues, 
    yearFilter, 
    year, 
    topPlatforms, 
    topCountries, 
    topReleases, 
    platformsData, 
    lastMonthRevenue, 
    balance,
    hasData,
    setAnalyticsData,
    updateYearFilter,
  } = useAnalyticsStore()
  const debouncedSearchQuery = useDebounce(searchQuery, 500); // 500ms debounce delay
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };


  
  // Local state for UI components that don't need to be persisted
  const [releaseTracks, setReleaseTracks] = useState([])
  const [previewTitle, setPreviewTitle] = useState('')
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Calculate the index range for the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  
  // Query for fresh data
  const { isLoading, isError, data: analytics } = useQuery({
    queryKey: ['adminAnalytics', "67bac6ae0017d8ab983f047e"],
    queryFn: () => getUserAnalytics("67bac6ae0017d8ab983f047e"),
    select: (data) => snakeToCamel(data),
  });
  
  // Process fresh data when it arrives, but only if it's different from what we have
  useEffect(() => {
    if(analytics){
      console.log("here analyics", analytics)
      setAnalyticsData(analytics);
    }
    // No need for this effect anymore as the setAnalyticsData in onSuccess handles it
  }, [analytics]);

  // Handle year filter change
  const handleYearChange = useCallback((selectedYear) => {
    updateYearFilter(selectedYear);
    
    // Force re-render of chart data
    setTimeout(() => {
      const chartElement = document.getElementById('revenue-chart');
      if (chartElement) {
        chartElement.style.opacity = '0.5';
        setTimeout(() => {
          chartElement.style.opacity = '1';
        }, 100);
      }
    }, 0);
  }, [updateYearFilter]);

  /////// RELEASES PAGINATION ////////
  

  const ctx = document.createElement('canvas').getContext('2d');
  const gradient = ctx.createLinearGradient(0, 0, 0, 300);
  gradient.addColorStop(0, '#4b95e9');    // Start color (#4b95e9)
  gradient.addColorStop(1, '#4b95e93a');

  



  /////////// PAGINATION ///////////
 

  const handlePageChange = (pageNumber) => {
      setCurrentPage(pageNumber);
      setPage(pageNumber)
  };
  


  ///////////// FLATEN RELEASES ///////////////
  // TODO: move to backend
  const flattenReleases = ""
  //  releases.reduce((accumulator, item) => {
  //   if(item.trackStats){
  //     const { title, trackStats } = item;
  //     const flatTracks = trackStats?.map(track => ({
  //       release: title,
  //       track: track.track,
  //       streams: track.streams,
  //       revenue: track.revenue
  //     }));
  //     return [...accumulator, ...flatTracks];
  //   }
  //   return accumulator;
  // }, []);


  const option = {
    color: ['#377099'],
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#6a7985'
        }
      }
    },
    toolbox: {
      feature: {
        saveAsImage: {}
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        boundaryGap: false,
        data: filteredValues?.map(item => item.monthYear)
      }
    ],
    yAxis: [
      {
        type: 'value'
      }
    ],
    series: [
      {
        name: 'Revenue',
        type: 'line',
        stack: 'Total',
        smooth: true,
        lineStyle: {
          width: 0
        },
        showSymbol: true,
        areaStyle: {
          opacity: 0.8,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: '#377099'
            },
            {
              offset: 1,
              color: '#fff'
            }
          ]),
        },
        emphasis: {
          focus: 'series'
        },
        data: filteredValues?.map(item => item.totalPrice.toFixed(0))
      }
    ]
  };


  const option1 = {
    tooltip: {
      trigger: 'item'
    },
    legend: {
      type: "scroll",
      top: '10%',
      left: 'center',
      orient: 'horizontal',
      textStyle: {
        fontSize: 12
      }
    },
    grid: {
      top: '25%'
    },
    series: [
      {
        top: '25%',
        name: 'Revenue',
        type: 'pie',
        radius: ['50%', '100%'],
        avoidLabelOverlap: true,
        itemStyle: {
          borderRadius: 10,
          borderColor: '#fff',
          borderWidth: 2
        },
        label: {
          show: false,
          position: 'center'
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 15,
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: false
        },
        data: platformsData
      }
    ]
  };

   if (isLoading && !hasData) {
       return (
         <div className='dash-section'>
             <h1 className='dash-title'>Analytics</h1>
             <div className="row">
               <div className="col-lg-4 col-md-6 mt-3">
                   <div className="dash-card dash-widget">
                     <Shimmer width={'100%'} height={100} />
                   </div>
                 </div>
                 <div className="col-lg-4 col-md-6 mt-3">
                   <div className="dash-card dash-widget">
                     <Shimmer width={'100%'} height={100} />
                   </div>
                 </div>
                 <div className="col-lg-4 col-md-6 mt-3">
                   <div className="dash-card dash-widget">
                     <Shimmer width={'100%'} height={100} />
                   </div>
                 </div>
             </div>
             <div className="row">
               <div className="col-12 mt-4">
                 <div className="dash-card">
                     <div className="dash-card-heading mb-3">
                         <h2 className="dash-card-title"><Shimmer width={150} height={20} /></h2>
                     </div>
                     <Shimmer width={'100%'} height={300} />
                 </div>
               </div>
               <div className="col-lg-6 mt-4">
                 <div className="dash-card mb-4 sorting-card">
                   <div className="dash-card-heading mb-2">
                     <h2 className="dash-card-title"><Shimmer width={120} height={20} /></h2>
                   </div>
                   <div className="top-items">
                       <Shimmer width={'100%'} height={150} />
                   </div>
                 </div>
                 <div className="dash-card sorting-card">
                   <div className="dash-card-heading mb-2">
                     <h2 className="dash-card-title"><Shimmer width={120} height={20} /></h2>
                   </div>
                     <div className="top-items">
                         <Shimmer width={'100%'} height={150} />
                     </div>
                 </div>
               </div>
               <div className="col-lg-6 mt-4">
                 <div className="dash-card">
                   <div className="dash-card-heading mb-3">
                     <h2 className="dash-card-title"><Shimmer width={120} height={20} /></h2>
                   </div>
                   <Shimmer width={'100%'} height={300} />
                 </div>
               </div>
   
               <div className="col-12 mt-4">
                   <div className="dash-card">
                       <div className="dash-card-heading">
                           <h2 className="dash-card-title">
                               <Shimmer width={100} height={20} />
                           </h2>
                           <div  className="dash-card-heading-btn">
                             <Shimmer width={80} height={20} />
                           </div>
                       </div>
                       <div className="table-responsive mt-3">
                           <Shimmer width={'100%'} height={200} />
                       </div>
                   </div>
               </div>
             </div>
         </div>
       );
     }
   
     if (isError) {
       return <div className='dash-section'><h1 className='dash-title'>Analytics</h1><div>Error fetching analytics data. Please try again later.</div></div>;
     }
   
     
  return (
    <div className='dash-section'>
        <h1 className='dash-title'>Analytics</h1>
        <div className="row">
          <div className="col-lg-4 col-md-6 mt-3">
              <div className="dash-card dash-widget">
                <div className="dash-widget-left">
                  <h1>${balance}</h1>
                  <h5>Current Balance</h5>
                </div>
                <div className="dash-widget-right">
                  <i class="fi fi-sr-donate"></i>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-3">
              <div className="dash-card dash-widget">
                <div className="dash-widget-left">
                  <h1>${lastMonthRevenue}</h1>
                  <h5>Latest Month Revenue</h5>
                </div>
                <div className="dash-widget-right">
                    <i class="fi fi-sr-hand-holding-usd"></i>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-3">
              <div className="dash-card dash-widget">
                <div className="dash-widget-left">
                    <h1>-</h1>
                    <h5>Total Paid</h5>
                </div>
                <div className="dash-widget-right">
                    <i class="fi fi-ss-piggy-bank"></i>
                </div>
              </div>
            </div>
        </div>
        <div className="row">
          <div className="col-12 mt-4">
            <div className="dash-card">
              <div className="dash-card-heading mb-3">
                  <h2 className="dash-card-title">Monthly Revenue</h2>
                  <div className="date-range-selector">
                    {
                      filteredValues.length > 0 && (
                        <div className="dash-form-group">
                          <label>Year</label>
                          <div className="dropdown dash-form-dropdown">
                              <button className="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                  {year}
                              </button>
                              <ul className="dropdown-menu">
                                  {
                                      yearFilter.map((item, i) => (
                                          <li 
                                            key={i}
                                            onClick={() => handleYearChange(item)}  
                                            className={year === item ? 'active' : ''}
                                          >
                                              {item}
                                          </li>
                                      ))
                                  }
                              </ul>
                          </div>
                        </div>
                      )
                    }
                  </div>
              </div>
              {
                filteredValues.length > 0 ? (
                  <div id="revenue-chart">
                    <ReactEcharts option={option} />
                  </div>
                ) : (
                  <div className="no-data">No Data</div>
                )
              }
            </div>
          </div>
          <div className="col-6">
            <div className="mt-4">
              <TopList 
                title="Top Countries" 
                items={topCountries} 
                labelKey="territory" 
                valueKey="totalRevenue" 
              />
            </div>
            <div className="mt-4">
              <TopList 
                title="Top Releases" 
                items={topReleases} 
                labelKey="title" 
                valueKey="totalRevenue" 
                formatValue={(value) => value?.toFixed(2)}
              />
            </div>
          </div>
          <div className="col-6 mt-4">
            <TopPlatformList 
              title="Top Platforms"
              items={topPlatforms}
              chartOption={option1}
            />
          </div>

          <div className="col-12 mt-4">
              <div className="dash-card">
                  <div className="d-flex flex-wrap justify-content-between">
                    <div>
                      <h2 className="dash-card-title">Releases</h2>
                      <input type="text" className='dash-input'  value={searchQuery}
        onChange={handleSearchChange} placeholder='Search...' />
                    </div>
                      <CSVLink className="dash-card-heading-btn" data={flattenReleases} filename={'releases.csv'}>
                        <i className="fi fi-rr-file-export me-2"></i>
                        Export CSV
                      </CSVLink>
                  </div>
                  {
                    <ReleaseStatsTable previewTitle={previewTitle} setReleaseTracks={setReleaseTracks} setPreviewTitle={setPreviewTitle} searchQuery={searchQuery} uid={''}></ReleaseStatsTable>
                  }
              </div>
          </div>
        </div>

        {/* MODAL */}
        
    </div>
  )
}

export default AdminAnalytics